import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpGlossary(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/glossary`, {revalidateOnFocus: false})
    return {
        ecpGlossary: data,
        mutateEcpGlossary: mutate,
        isLoadingEcpGlossary: !error && !data,
        isErrorEcpGlossary: error
    }
}